import { Beacon } from '@/components/forms/FormContext';
import {
	type StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

export const contactInfoStepGraph: Beacon<StepMap> = {
	[steps.ContactInfo]: [],
};
